module.exports = __webpack_public_path__ + "img/schulung.ede3d64e.png";